/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FindingSeverity {
  Information = 'Information',
  Average = 'Average',
  Elevated = 'Elevated',
  High = 'High',
  NotAppropriate = 'NotAppropriate'
}
